import { render } from "./FieldFolders.vue?vue&type=template&id=33d990b6&ts=true&lang=pug"
import script from "./FieldFolders.vue?vue&type=script&lang=ts"
export * from "./FieldFolders.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__